import {
  IEmployeePaymentMethod,
  IMenhirEmployeePaymentMethod,
  IPaymentMethodSetupIntent,
  MenhirPaymentMethodSetupIntent,
} from '@/common/integrations/menhir/employee/payments/payments.types';

export const transformPaymentMethodIntent = (
  setupIntent: MenhirPaymentMethodSetupIntent
): IPaymentMethodSetupIntent => ({
  clientSecret: setupIntent.payment_method.client_secret,
});

export const transformPaymentMethods = (
  paymentMethods: IMenhirEmployeePaymentMethod[]
): IEmployeePaymentMethod[] => paymentMethods.map(transformPaymentMethod);

export const transformPaymentMethod = (
  paymentMethod: IMenhirEmployeePaymentMethod
): IEmployeePaymentMethod => ({
  id: paymentMethod.id,
  customerId: paymentMethod.customer_id,
  customerType: paymentMethod.customer_type,
  paymentAccount: paymentMethod.payment_account,
  paymentMethodId: paymentMethod.payment_method_id,
  paymentType: paymentMethod.payment_type,
  providerCustomerId: paymentMethod.provider_customer_id,
  providerId: paymentMethod.provider_id,
  providerPaymentMethodId: paymentMethod.provider_payment_method_id,
  metadata: {
    brand: paymentMethod.metadata.brand,
    country: paymentMethod.metadata.country,
    expMonth: paymentMethod.metadata.exp_month,
    expYear: paymentMethod.metadata.exp_year,
    last4Digits: paymentMethod.metadata.last_4_digits,
  },
});
